export const up = 38;
export const down = 40;
export const left = 37;
export const right = 39;

export const enter = 13;
export const space = 32;
export const backspace = 46;
export const escape = 27;
